 $(document).ready(function() {
    // Initialize Slick Slider
    $('.slick-slider-cus').slick({
      autoplay: true,       // Set autoplay
      autoplaySpeed: 3000, 
      arrows: false,         
      dots: false,         
      infinite: true,       
      slidesToShow: 3,     
      slidesToScroll: 3,
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
    
  ]
    });
  });